/**
 * Care-level display metadata for CareStart triage results.
 *
 * WHAT: maps a resolved careLevel ("ER" | "UrgentCare" | "PrimaryCare" | "Specialist")
 *   to the patient-facing headline, subhead, MUI color, and icon shown in the care-level
 *   badge ("Consider an Emergency visit.", etc.).
 * WHY: this copy/color set is now rendered in two places — the right-column CareLevelBadge
 *   (anonymous live flow) and TriageResultPanel (authenticated post-auth restore flow).
 *   Keeping it here prevents the two from drifting apart.
 *
 * Tightest coupling: CareLevelBadge.jsx and TriageResultPanel.jsx both key into this by the
 *   careLevel string produced by deriveCareGuidance.resolveCareLevel.
 */
export const CARE_LEVEL_DISPLAY = Object.freeze({
  ER: {
    label: "Consider an Emergency visit.",
    sublabel: "This may need immediate attention.",
    muiColor: "error",
  },
  UrgentCare: {
    label: "Urgent Care can help with this",
    sublabel: "Go today. Most urgent care centers do not need an appointment.",
    muiColor: "warning",
  },
  PrimaryCare: {
    label: "Schedule with your doctor",
    sublabel: "This doesn't need emergency care, but don't ignore it.",
    muiColor: "success",
  },
  Specialist: {
    label: "You may need a specialist",
    sublabel: "Start with your primary care doctor for a referral.",
    muiColor: "info",
  },
});

export default CARE_LEVEL_DISPLAY;
